import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class WeekSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');
    this.dom.progress = this.dom.slider.querySelector('.splide-carousel-progress-bar');
    this.dom.controller = {
      prev: this.dom.slider.querySelector('[data-arrow="prev"]'),
      next: this.dom.slider.querySelector('[data-arrow="next"]'),
    }

    this.slider = null;
    this.total = null;
    this.rate = null;
    this.initView = 4;
    this.currentIndex = 1;
    this.adjustment = (window.innerWidth >= 768) ? 4 : 1;

    this.playPrev = this.playPrev.bind(this);
    this.playNext = this.playNext.bind(this);

    this.option = {
      autoplay: false,
      type: 'slide',
      // perMove: 4,
      autoWidth: true,
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      // interval: 5000,
      speed: 900,
      arrows: false,
      pagination: false,
      gap: `min(${24 / 16}rem, ${24 / 360 * 100}vw)`,
      padding: { right: `min(${24 / 16}rem, ${24 / 360 * 100}vw)` },
      mediaQuery: 'min',
      breakpoints: {
        768: {
          gap: `min(${32 / 16}rem, ${32 / 1280 * 100}vw)`,
          padding: { right: 0 },
        }
      }
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    this.slider.on('mounted move', (newIndex, prevIndex, destIndex) => {
      this.total = this.slider.Components.Controller.getEnd() + 1;
      this.rate = Math.min( ( this.slider.index + this.adjustment ) / this.total, 1 );
      this.dom.progress.style.width = String( 100 * this.rate ) + '%';

      this.currentIndex = (newIndex !== undefined) ? newIndex : 0;
    } );
    this.slider.mount();

    this.dom.controller.prev.addEventListener('click', this.playPrev);
    this.dom.controller.next.addEventListener('click', this.playNext);
  }

  playPrev() {
    if (window.innerWidth >= 768) {
      if (this.currentIndex === 0) {
        this.slider.go(this.initView - 1)
      } else {
        this.slider.go('-1')
      }
    } else {
      this.slider.go('-1')
    }
  }
  
  playNext() {
    if (window.innerWidth >= 768) {
      if (this.currentIndex === (this.total - this.initView)) {
        this.slider.go(0)
      } else {
        this.slider.go('+1')
      }
    } else {
      this.slider.go('+1')
    }

  }
}

export default WeekSlides